import { useWatch, useFormContext } from "react-hook-form";
import { TextField } from "vino/core/forms";
import { State, Country } from "../../lookups";
import AddressAutoComplete from "./AddressSearch";

const Address = () => {
	const { control } = useFormContext();
	const countryId = useWatch({ control, name: "address.countryId" });

	return (
		<>
			<div className="mb-16 w-full">
				<AddressAutoComplete />
			</div>
			<div className="mb-16 w-full">
				<TextField
					name="address.addressLine1"
					label="Address"
					required
					fullWidth
				/>
			</div>
			<div className="mb-16 w-full">
				<TextField
					name="address.addressLine2"
					label="Apartment, suite, etc. (optional)"
					fullWidth
				/>
			</div>
			<div className="mb-16 w-full">
				<TextField name="address.city" label="City" required fullWidth />
			</div>
			<div className="flex justify-evenly mb-16">
				<div className="flex-1">
					<Country name="address.countryId" required fullWidth />
				</div>
				<div className="flex-1 mx-5">
					<State
						name="address.stateId"
						countryId={countryId}
						required
						fullWidth
					/>
				</div>
				<div className="flex-1">
					<TextField
						name="address.zipCode"
						label="Zip Code"
						required
						fullWidth
					/>
				</div>
			</div>
		</>
	);
};

export default Address;
